/**
 * @module Helpers
 */
import * as _ from 'lodash';
import Env from '@/env';
import store from '@/store/store';
import moment from 'moment';
import { id } from 'date-fns/locale';

export default {
  /**
   * Accept array and callback function
   * @param {items} - returns array
   */
  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  },

  /**
   * Accept array and returns bool
   * @param {items} - returns array
   */
  async validateRefs(self, items) {
    var validationPass = true;

    return this.asyncForEach(items, async item => {
      let res = await self.$refs[item].validate();
      if (!res.valid) {
        validationPass = false;
      }
    }).then(() => {
      return validationPass;
    });
  },

  /**
   *
   * @param {*} data : Accept object
   * @returns : blank key value of given obj
   */
  setObjValueEmpty(data) {
    // eslint-disable-next-line
    for (const key in data) {
      data[key] = '';
    }
    return data;
  },

  /**
   * Check if all location variants are out of stock
   * Returns true if all variants are not available
   */

  isAllVariantOutOfStock(variants) {
    if(variants.length < 1){
      return true;
    }
    // if at least 1 variant is available then variant at stock
    let availableVariant = _.find(variants, function(o) { return o.available == true; });
    if(availableVariant == undefined){
      return true;
    }
    return false;
  },

  /**
   * get store default image
   */
  getStoreFeaturedImage(images){
    if(!images || images == undefined || images && images.length < 1){
      return '';
    }
    let featuredImage = _.find(images, { is_default: true});
    if(featuredImage == undefined){
      // none of image are set default get first one 
      return '';
    }
    return featuredImage.image_url;
  },

  /**
   * 
   * Sale price detect
   */
  hasSaleTag(variants){
    return variants.some(function (value, index, _arr) {
      return parseFloat(value.sale_price) > 0 && parseFloat(value.sale_price) < parseFloat(value.price);
    }); 
  },
  /**
   * Checkout key value for gtag
   */
  GTagKeyValueForChekout(arr) {
    let data = [];
    arr.forEach(item => {
      data.push({
        id: item.location_product_id ? item.location_product_id : null,
        name: item.product_name ? item.product_name : null, 
        brand: item.brand_name ? item.brand_name : null,
        category: item.category_name ? item.category_name : null,
        variant: item.selected_variant.size ? item.selected_variant.size : null,
        quantity: parseInt(item.unit),
        price: item.price,
      })
    })
    return data;
  },

  /**
   * Catch error message
   * if obj has payload then get first item from array else fallbat to msg
   */
  catchErrorMessage(obj){
    if(_.has(obj, 'payload')) {
      return obj.payload[0];
    } 
    return obj.msg ? obj.msg : 'Please try again later.';
  },
  /**
   * Create key val, parameter
   */
  generateUrlParameter(obj) {
    let params = '';
    for (let key in obj) {
      if (Array.isArray(obj[key])) {
        // Push to apionly if has value
        if (obj[key].length > 0) {
          // if (key == 'thc') {
          //   params += `&${key}=${obj[key].join('|')}`;
          // } else {
            params += `&${key}=${obj[key].join()}`;
          // }
        }
      } else {
        params += obj[key] ? `&${key}=${obj[key]}` : '';
      }
    }
    return params;
  },


  /**
   * Create key val, parameter for size
   */
   generateSizeUrlParameter(filterObj, mainCatObj) {
    var obj = _.clone(filterObj); // to protect 2 way filter binding values
    let params = '';
    let removeUnnecessaryKeys = ['sort', 'size'];
    removeUnnecessaryKeys.forEach(rmvKeys => {
      delete obj[rmvKeys]; 
    })

    // Check if the key from_categories exist if so then its sub cat active else not, 
    // If no sub cat active we need to send parent cat
   if( obj.from_categories && (obj.from_categories.length < 1) ){
     // Need to push sub cat if available
     if(!_.isEmpty(mainCatObj)){
      let cats =[mainCatObj.id];
      if((mainCatObj.from_categories )&& (mainCatObj.from_categories.length > 0) ){
        // Need to show weight/ size from child cat if availble when main cat is active
        mainCatObj.from_categories.forEach(item => {
          cats.push(item.id);
        })
      }
      obj.from_categories = cats;
     }
    
   }

    for (let key in obj) {
      if (Array.isArray(obj[key])) {
        // Push to apionly if has value
        if (obj[key].length > 0) {
          params += `&${key}=${obj[key].join()}`;
        }
      } else {
        params += obj[key] ? `&${key}=${obj[key]}` : '';
      }
    }

    if(params.charAt(0) == '&') {
      params = '?'+ params.substring(1);
    }
    // Now we have special case 
    // if brands is available then push include_brands=1
    if(params.indexOf('brands') > 0){
      params += '&include_brands=1';
    }
    // if plant_type or product_from are available then push include_cannabis_attributes=1
    if( (params.indexOf('plant_type') > 0 ) || (params.indexOf('product_from') > 0) ){
      params += '&include_cannabis_attributes=1';
    }
    // if thc or cbd is available then push include_thc_cbd=1
    if( (params.indexOf('thc') > 0) || ( params.indexOf('cbd') > 0) ){
      params += '&include_thc_cbd=1';
    }

    return params;
  },

  /**
   * Create key val, parameter
   */
  generateUrlParameterIgnoreSubcat(obj) {
    let params = '';
    for (let key in obj) {
      if( key != 'parent_category') { // parent category is only for frontend
        if(key != 'from_categories'){
          if (Array.isArray(obj[key])) {
            // Push to api only if has value
            if (obj[key].length > 0) {
              // if (key == 'thc') {
              //   params += `&${key}=${obj[key].join('|')}`;
              // } else {
                params += `&${key}=${obj[key].join()}`;
              // }
            }
          } else {
            params += obj[key] ? `&${key}=${obj[key]}` : '';
          }
        }
      }
    }
    return params;
  },

  /**
   * Returns active filter active count based on the countFilters array
   */
   getActiveFilterCount(obj) {
    let count = 0;
    let countFilters = ['brands', 'plant_type', 'product_form', 'size', 'thc', 'cbd'];
    for (let key in obj) {
        if(countFilters.indexOf(key) != -1){
          // if the key value if array type then check if there is any value
          if ( (Array.isArray(obj[key])) && (obj[key].length > 0)) {
            count += obj[key].length;
          } else if(obj[key] != '') {
            count++;
          }
        }
    }
    return count;
   },

   /**
    * Returns active filters tags based on filter
    */
    getActiveFilterTags(obj) {
      let tags = [];
      if(obj.on_sale)  {
        tags.push({
          key: 'on_sale',
          val: true,
          displayVal: 'On Sale',
        })
      }
      let countFilters = ['brands', 'plant_type', 'product_form', 'size', 'thc', 'cbd'];
      for (let key in obj) {
        if(countFilters.indexOf(key) != -1){
          // if the key value if array type then check if there is any value
          if ( (Array.isArray(obj[key])) && (obj[key].length > 0)) {
            obj[key].forEach(item => {
              // Need to format values because need to pass different value in api need to show different on frontend
              if(key == 'thc' ||  key == 'cbd') {
                tags.push({
                  key: key,
                  val: item,
                  displayVal: item ? item.charAt(0).toUpperCase() + item.slice(1) + ' ' + key.toUpperCase(): '',
                })
              } else {
                tags.push({
                  key: key,
                  val: item,
                  displayVal: item ? item.charAt(0).toUpperCase() + item.slice(1) : '',
                })
              }
            })
          } else if(obj[key] != '') {
            tags.push({
              key: key,
              val: obj[key],
              displayVal: obj[key] ? obj[key].charAt(0).toUpperCase() + obj[key].slice(1) : '',
            })
          }
        }
      }
      return tags;
     },

   
   
  /**
   * Remove key from object
   */
  unsetKeyFromObj(arr, obj) {
    arr.forEach(item => {
      if(Object.prototype.hasOwnProperty.call(obj, item)){
        delete obj[item]
      }
    })
    return obj;
  },

  /**
   * Get variant display type
   */
  getVariantDisplayType(arr) {
    let displayType = "list"; // this is by default
    for (let item of arr) {
      if(item.size && (item.size.length >= 8) ){
        displayType = "select"; 
        break;
      }
    };
    return displayType;
  },

  /**
   * Get total number of addable variants
   */
  getTotalNumberOfAddableVariants(arr) {
    let addAbleCount = 0;
    for (let item of arr) {
      if( (item.available == true) && (item.no_of_units > item.inventory_threshold)){
        addAbleCount++;
      }
    }
    return addAbleCount;
  },


  /**
   * Get unique product variant if product family == cannabis, unique by name name 
   */
   getUniqueProductVariants(product_family, variants) {
    return _.uniqBy(variants, function(elem) {
    // Make uniqe product only for cannabis
      if(product_family == 'cannabis'){
        return JSON.stringify(_.pick(elem, ['size'])); // we change it to size as per conversation from name to size
      } 
      return elem;
    })
  },
  
  /**
   * Attach out of stock key on variant, depending on this we show variant is out of stock
   */
  attachOutOfStockKey(variants) {
    return variants.map((item) => {
      if( (item.available == true) && (item.no_of_units > item.inventory_threshold)){
         item._in_stock = true;
      } else {
        item._in_stock = false;
      }
       return item;
    })
  },

  /**
   * Get first available variant
   */

  getFirstAvailableVariant(variants){
    if(variants.length > 0){
      for (let index in variants) {
        // variants must be available and no_of_units > inventory_threshold
        if(variants[index].available == true && variants[index].no_of_units > variants[index].inventory_threshold){
          return variants[index];
        }
      }
    }
    return {};
  },

  /**
   * 
   * Get first sale variant
   */

   getFirstSaleVariant(variants){
    if(variants.length > 0){
      let variant = {};
      variants.forEach(item => {
        if(item.sale_price && item.sale_price < item.price){
          if(_.isEmpty(variant)){
            variant = item
          }
        }
      })
      if(!_.isEmpty(variant)){
        return variant;
      }
    }
    return null;
  },

  /**
   * Pubnub subscribe all channel
   */
   pubnubSubscribeAllChannels({ user_id, location_id}) {
    if(!window.pubnub){
      return;
    }
    let channels = [];
    channels.push('user-' + user_id);
    channels.push('user-' + user_id + '-notifications');
    if(location_id && (location_id !== undefined)){
      channels.push(location_id + '-user');
      channels.push('user-' + user_id + '-location-' + location_id);
    }
    window.pubnub.subscribe({
      channels
    });
    return true;
  },

  /**
   * Pubnub unsubscribe all channel
   */
   pubnubUnSubscribeAllChannels({ user_id, location_id}) {
    if(!window.pubnub){
      return;
    }
    let channels = [];
    channels.push('user-' + user_id);
    channels.push('user-' + user_id + '-notifications');
    if(location_id && (location_id !== undefined)){
      channels.push(location_id + '-user');
      channels.push('user-' + user_id + '-location-' + location_id);
    }
    window.pubnub.unsubscribe({
      channels: channels,
    });
    window.pubnub.unsubscribeAll();

    window.pubnub.removeAllListeners();
    window.pubnub.removeListener(window.pubnubListners ? window.pubnubListners : {});
    
    return true;
  },

  /**
   * Pubnub subscribe channel
   */
   setPubNubUserLocationSubscribe({ user_id, location_id}) {
     // "${location_id}-user"
     if(!window.pubnub){
       return;
     }
    let subscribedChannels = window.pubnub.getSubscribedChannels();
    let channelName = location_id+'-user';
    if(subscribedChannels.length > 0){
      // Now check whether the channel is already subscribed 
      if(subscribedChannels.indexOf(channelName) == -1){
        // channel is not in list lets subscribe
        let channels = [];
        // console.log(channelName + ' - subscribe')
        channels.push(channelName);
        window.pubnub.subscribe({
          channels
        });
        return true;
      } 
    }
    return false;
   },

   /**
   * Pubnub unsubscribe channel
   */
  unsubscribePubnubLocationUser({ user_id, location_id}) {
    if(!window.pubnub){
      return;
    }
    let subscribedChannels = window.pubnub.getSubscribedChannels();
    if( subscribedChannels.length > 0){
      // Now check whether the channel is already subscribed 
      if(subscribedChannels.indexOf(location_id + '-user') > -1){
        //console.log('subscribed channels from helper ' + channelName)
        let channels = [];
        channels.push(location_id + '-user')
        channels.push('user-' + user_id + '-location-' + location_id);
        window.pubnub.unsubscribe({
          channels,
        })
        return true;
      } 
    }
    return false;
  },

  /**
   * Returns full url from given context and product_id
   */
  getLocationProductFullUrl(context, product_id) {
    if(!context || !product_id){
      return '';
    }
    let contextRoute = context.$router.resolve({
      name: 'LocationProductDetail',
       params: {
        business_slug: context.$route.params.business_slug,
        store_slug: context.$route.params.store_slug ? context.$route.params.store_slug : store.getters['location/selected'].slug,
        product_id: product_id
      }
    })
    return window.location.protocol + "//" + window.location.host + contextRoute.href;
  },

  /**
   * Returns full cart url from context, later changed ot checkout
   */
   getLocationCartFullUrl(context) {
    if(!context){
      return '';
    }
    let contextRoute = context.$router.resolve({
      name: 'Checkout',
       params: {
        business_slug: context.$route.params.business_slug,
        store_slug: context.$route.params.store_slug ? context.$route.params.store_slug : store.getters['location/selected'].slug,
      }
    })
    return window.location.protocol + "//" + window.location.host + contextRoute.href;
  },

  /**
   * Create facebook sdk js
   */
  async loadFacebookSDK(){

    // If no fb root element then generate
    if (!document.getElementById('fb-root')) {
      const fbDiv = document.createElement("div");
      fbDiv.id = "fb-root";
      document.body.appendChild(fbDiv);
    }

    let s = 'script';
    let id = 'facebook-jssdk';
    var js,
      fjs = document.getElementsByTagName(s)[0];
    if (document.getElementById(id)) {
      return;
    }
    js = document.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  },

  /**
   * Initialize facebook
   */

  async initFacebook(loggedIn) {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: Env.facebookAppId,
        cookie: false, 
        status: true,
        xfbml: true,
        version: "v12.0"
      });
      if(!loggedIn){
        window.FB.getLoginStatus((fbloginRes) =>{
          if(fbloginRes.status == 'connected'){
            window.FB.logout(function(){
              console.log('fb out.')
            });
          }
        })
      }
    };
  },
  
  /**
   * Get facebook loggedin user info
   */
  removeFbCookeFromLocal() {
    if(window.FB){
      window.FB.getLoginStatus((fbloginRes) =>{
        if(fbloginRes.status == 'connected'){
          window.FB.logout(function(){});
        }
      })
    }
  },

  /**
   * Get location product category unique sizes
   */
  getUniqueSizes(res) {
    let response = [];
    res.data.payload.products.forEach(sizeItem => {
      if(sizeItem.variants){
        sizeItem.variants.forEach( sizeInnerItem => {
          if(sizeInnerItem.size){
            response.push(sizeInnerItem.size)
          }
        })
      }
    })
    return _.uniq(response);
  },
  /**
   * Get category first item product form 
   */
  getCategoryFirstProductProductForm(categoryProducts) {
    if( (categoryProducts.length > 0) && (categoryProducts[0].cannabis_attributes)){
      return categoryProducts[0].cannabis_attributes.product_form;
    }
    return '';
  },

  /**
     * Load elavon js 
     */
   loadElavonJs(jsUrl) {
    const self = this;
    // remove existing if any to prevent double 
    var elavonLib = document.getElementById("elavon_js");
    if (elavonLib) {
      elavonLib.parentNode.removeChild(elavonLib)
    }
    // get all js and check if we have already loaded this js
    var allScript = document.scripts;
    for (var i = 0, max = allScript.length; i < max; i++) {
      if (allScript[i].src == jsUrl)
        return;
    }

    new Promise(function (resolve, reject) {
      let sc = document.createElement('script');
      sc.setAttribute('id', 'elavon_js');
      sc.src = jsUrl;
      document.head.appendChild(sc);
      sc.onload = function () {
         console.log('elevon loaded') 
        // Trigger ends 
        resolve();
      };
    });
  },


  /**
     * Load elavon js 
     */
   async loadCloverJs(jsUrl) {
    const self = this;
    // remove existing if any to prevent double 
    var elavonLib = document.getElementById("clover_js");
    if (elavonLib) {
      elavonLib.parentNode.removeChild(elavonLib)
    }
    // get all js and check if we have already loaded this js
    var allScript = document.scripts;
    for (var i = 0, max = allScript.length; i < max; i++) {
      if (allScript[i].src == jsUrl)
        return;
    }

    await new Promise(function (resolve, reject) {
      let sc = document.createElement('script');
      sc.setAttribute('id', 'clover_js');
      sc.src = jsUrl;
      document.head.appendChild(sc);
      sc.onload = function () {
         console.log('clover loaded') 
        // Trigger ends 
        resolve();
      };
    });
  },

    /**
     * load paysafe js 
     */
   loadPaysafeJs(jsUrl, token_key) {
      
    const self = this;
    // remove existing if any to prevent double 
    var paysafeLib = document.getElementById("paysafe_js");
    if (paysafeLib) {
      paysafeLib.parentNode.removeChild(paysafeLib)
    }
    // get all js and check if we have already loaded this js
    var allScript = document.scripts;
    for (var i = 0, max = allScript.length; i < max; i++) {
      if (allScript[i].src == jsUrl)
        return;
    }

    new Promise(function (resolve, reject) {
      let sc = document.createElement('script');
      sc.setAttribute('id', 'paysafe_js');
      sc.src = jsUrl;
      document.head.appendChild(sc);
      sc.onload = function () {
        console.log('loaded paysafe')
        paysafe.fields.setup(token_key, Env.paysafe.options, function (instance, error) {
          window.paysafeInstance = instance;
        });
        // Trigger ends 
        resolve();
      };
    });
  },


   /**
     * Get the value from gmap auto component
     */
    getDetailFromGmapAutoComplete(address_components, $key, type = 'long_name') {
      let returnValue = '';
      let searchdata = address_components.find(item => {
        if (_.indexOf(item.types, $key) > -1) {
          return item;
        }
      })
      if (searchdata != undefined) {
        returnValue = searchdata[type]
      }
      return returnValue;
    },

    /**
     * Get THC Value
     */
    getTHCValue(productDetail) {
      // if no key available , blank
      // if key available but no data , blank
      // if value is less than 1 do not ceil
      // if less than 1 then show decimal 1 values 
      // re update show all single decimal

      if(productDetail && productDetail.thc_cbd_levels){
        let thcMin = (productDetail.thc_cbd_levels.thc_min ? productDetail.thc_cbd_levels.thc_min : 0).toFixed(1);
        let thcMax = (productDetail.thc_cbd_levels.thc_max ? productDetail.thc_cbd_levels.thc_max : 0).toFixed(1);
        let thc = (productDetail.thc_cbd_levels.thc ? productDetail.thc_cbd_levels.thc : 0).toFixed(1);

        if(productDetail.category && productDetail.category.thc_cbd_value_type){

          // New case if thc min == thc max OR value type is single
          if( (thcMin == thcMax) || productDetail.category.thc_cbd_value_type == 'single'){
            // If value is zero
            return thc + productDetail.thc_cbd_levels.concentration_unit;
          }
          // Else fall back to range
          return (thcMin == 0 && thcMax == 0) ? 0.0 + productDetail.thc_cbd_levels.concentration_unit : thcMin + ' - ' + thcMax + productDetail.thc_cbd_levels.concentration_unit;

        } else {
          // Fall back to range
          return (thcMin == 0 && thcMax == 0) ? 0.0 + productDetail.thc_cbd_levels.concentration_unit : thcMin + ' - ' + thcMax + productDetail.thc_cbd_levels.concentration_unit;
        }
      }
      return '';
    },

    /**
   * Get CBD Value
   */
    getCBDValue(productDetail) {
      if(productDetail && productDetail.thc_cbd_levels){

        let cbdMin = (productDetail.thc_cbd_levels.cbd_min ? productDetail.thc_cbd_levels.cbd_min : 0).toFixed(1);
        let cbdMax = (productDetail.thc_cbd_levels.cbd_max ? productDetail.thc_cbd_levels.cbd_max : 0).toFixed(1);
        let cbd = (productDetail.thc_cbd_levels.cbd ? productDetail.thc_cbd_levels.cbd : 0).toFixed(1);

        if(productDetail.category && productDetail.category.thc_cbd_value_type){

          // New case if thcmin == thx mac then show single value OR value type single
          if( (cbdMin == cbdMax) || productDetail.category.thc_cbd_value_type == 'single' ){
            return cbd + productDetail.thc_cbd_levels.concentration_unit;
          }
          // Else fall back to range
          return (cbdMin == 0 && cbdMax == 0) ? 0.0 + productDetail.thc_cbd_levels.concentration_unit : cbdMin + ' - ' + cbdMax + productDetail.thc_cbd_levels.concentration_unit;

        } else {
          // Fall back to range
          return (cbdMin == 0 && cbdMax == 0) ? 0.0 + productDetail.thc_cbd_levels.concentration_unit : cbdMin + ' - ' + cbdMax + productDetail.thc_cbd_levels.concentration_unit;
        }
      }
      return '';
    },

    /**
     * Get THC Value for cart item
     */
    getTHCValueForCart(item) {
      if(item && !_.isEmpty(item.thc_cbd_levels) ){
    
        let thcMin = (item.thc_cbd_levels.thc_min ? item.thc_cbd_levels.thc_min : 0).toFixed(1);
        let thcMax = (item.thc_cbd_levels.thc_max ? item.thc_cbd_levels.thc_max : 0).toFixed(1);
        let thc = (item.thc_cbd_levels.thc ? item.thc_cbd_levels.thc : 0).toFixed(1);

        if(item.thc_cbd_value_type){
          
          // if same value OR value type single => show single 
          if( (thcMin == thcMax) || (item.thc_cbd_value_type == 'single')){
            return thc + item.thc_cbd_levels.concentration_unit;
          }
          // Else fall back to range
          return (thcMin == 0 && thcMax == 0) ? 0.0 + item.thc_cbd_levels.concentration_unit : thcMin + ' - ' + thcMax + item.thc_cbd_levels.concentration_unit;
          
        } else {
          // Fall back to range
          return (thcMin == 0 && thcMax == 0) ? 0.0 + item.thc_cbd_levels.concentration_unit : thcMin + ' - ' + thcMax + item.thc_cbd_levels.concentration_unit;
        }
      }
      return '';
    },

    /**
   * Get CBD Value for cart item 
   */
    getCBDValueForCart(item) {
      if(item && !_.isEmpty(item.thc_cbd_levels)){

        let cbdMin = (item.thc_cbd_levels.cbd_min ? item.thc_cbd_levels.cbd_min : 0).toFixed(1);
        let cbdMax = (item.thc_cbd_levels.cbd_max ? item.thc_cbd_levels.cbd_max : 0).toFixed(1);
        let cbd = (item.thc_cbd_levels.cbd ? item.thc_cbd_levels.cbd : 0).toFixed(1);

        if(item.thc_cbd_value_type){
          // New case if thcmin == thx mac then show single value OR value type single
          if( (cbdMin == cbdMax) || item.thc_cbd_value_type == 'single' ){
            return cbd + item.thc_cbd_levels.concentration_unit;
          }
         // Else fall back to range
         return (cbdMin == 0 && cbdMax == 0) ? 0.0 + item.thc_cbd_levels.concentration_unit : cbdMin + ' - ' + cbdMax + item.thc_cbd_levels.concentration_unit;

        } else {
          // Fall back to range
          return (cbdMin == 0 && cbdMax == 0) ? 0.0 + item.thc_cbd_levels.concentration_unit : cbdMin + ' - ' + cbdMax + item.thc_cbd_levels.concentration_unit;
        }
      }
      return '';
    },

    /**
     * Get product price/g vs price of pack
     */
    getProductFirstVariantPricePerWeight(item) {
      if(item.product_family != 'cannabis'){
        return '';
      }
      // DO not show price per gram for non dried flower
      if(item.cannabis_attributes && ( (item.cannabis_attributes.product_form == 'dried flower' ) || (item.cannabis_attributes.product_form == 'pre rolled') ) ){
      
        if(item.variants[0] && (item.variants[0].weight_equivalent_dry_cannabis != null) ){
          let dryEquiWeight = parseFloat(item.variants[0].weight_equivalent_dry_cannabis);
          if(item.variants[0].sale_price && (item.variants[0].sale_price < item.variants[0].price) ){
            if(dryEquiWeight == 0){
              return '$' + (item.variants[0].sale_price).toFixed(2) + '/' + item.weighing_unit;
            }
            return '$' + (item.variants[0].sale_price/dryEquiWeight).toFixed(2) + '/' + item.weighing_unit;
          }
          if(dryEquiWeight == 0){
              return '$' + (item.variants[0].price).toFixed(2) + '/' + item.weighing_unit;
            }
          return  '$' + (item.variants[0].price/dryEquiWeight).toFixed(2) + '/' + item.weighing_unit;
        }
      } else {
        return ''; // return blank for now
        if(item.variants[0].sale_price && (item.variants[0].sale_price < item.variants[0].price) ){
          return '$' + (item.variants[0].sale_price).toFixed(2) + '/' + item.weighing_unit;
        } else {
          return '$' + (item.variants[0].price).toFixed(2) + '/' + item.weighing_unit;
        }
      }
      return '';
    },
    /**
     * Collect all categories in an object
     */
    collectAllCategoriesInObj(bulkCategoryData) {
      if(bulkCategoryData.length > 0){
        let keyval = {};
        bulkCategoryData.forEach(item => {
          // this is for main
          keyval[item.id] = {
            name: item.name,
            id: item.id,
            thc_cbd_value_type: item.thc_cbd_value_type,
          }
          //this is for subcat
          if(item.subCategory && (item.subCategory.length > 0)){
            item.subCategory.forEach(subItem => {
              keyval[subItem.id] = {
                name: subItem.name,
                id: subItem.id,
                thc_cbd_value_type: subItem.thc_cbd_value_type,
              }
            })
          }
        })
        return keyval;
      } 
      return {};
    },

    /**
     * Collect recommend products for cart
     */
    collectRecommendProducts(categoryWithProducts, totaldataToreturn = 2) {
      let recommendProducts = [];
      categoryWithProducts.every(item => {
        if (recommendProducts.length < totaldataToreturn) {
          let categoryRecommendationProducts = item.categoryRecommendationProducts;
           categoryRecommendationProducts.every(innerItem => {
              if (recommendProducts.length < totaldataToreturn) {
                innerItem.category = {
                  thc_cbd_value_type: item.thc_cbd_value_type,
                  id: item.id,
                  name: item.name
                }
                delete innerItem.LocationCategoryRecommendation;
                recommendProducts.push(innerItem)
                return true;
              }
              return false;
           })
          return true;
        } else {
          return false;
        }
      });
      return recommendProducts;
    },

    /**
     * Refine Query
     * array is the key to remove from query
     */
    refineQuery(array, query) {
      array.forEach( (item) => {
        if(query.hasOwnProperty(item)){
          delete query[item];
        } 
      })
      return query;
    },

    /**
     * Get store next delivery / openhours
     */
    storeNextOpenDateTime(vg_selectedStore, type = 'delivery') {
      let todayInLocationDetail =  moment().tz( (vg_selectedStore.address && vg_selectedStore.address.timezone_id ) ? vg_selectedStore.address.timezone_id : 'America/Toronto');
      let nextOpenday = ''; 
      for(let i = 1; i <= 7; i++){
        let theday = todayInLocationDetail.add(1, 'day');
        let nextDay = theday.day(); 
        if(!nextOpenday){
          if(type == 'delivery') {
            if(vg_selectedStore.delivery_hours[nextDay]){
              if(vg_selectedStore.delivery_hours[nextDay] && vg_selectedStore.delivery_hours[nextDay].is_open){
                let deliveryDate = theday.format('YYYY-MM-DD') + ' '+ vg_selectedStore.delivery_hours[nextDay].open_time;
                nextOpenday = moment(deliveryDate).format("YYYY-MM-DD hh:mm a"); // 12 hour date time, because dropdown is non this format
              }
            }
          } else {
            if(vg_selectedStore.hours_of_operation[nextDay]){
              if(vg_selectedStore.hours_of_operation[nextDay] && vg_selectedStore.hours_of_operation[nextDay].is_open){
                let openingDate = theday.format('YYYY-MM-DD') + ' '+ vg_selectedStore.hours_of_operation[nextDay].open_time;
                nextOpenday = moment(openingDate).format("YYYY-MM-DD hh:mm a"); // lets make structure same as dropdown value
              }
            }
          }
        } else {
          break;
        }
      }
      return nextOpenday;
    },

     /**
     * Get store 30min plus time
     */
    storeNowAddedTime(vg_selectedStore, min = '30') {
      let currentTime = moment().tz( (vg_selectedStore.address && vg_selectedStore.address.timezone_id) ? vg_selectedStore.address.timezone_id : 'America/Toronto');
      let addMins = currentTime.add(min, 'minutes');
      return moment(addMins).format("YYYY-MM-DD hh:mm a"); // lets make structure same as dropdown value
    },

    /**
     * Emit user activity
     */
     emitUserActivity() {
      if(store.getters['getLoggedInUserId'] && window.pubnub && store.getters['location/selected'].id) {
         window.pubnub.publish({ 
           channel: 'user_activity',
           sendByPost: false, 
           message: {
             user_id: store.getters['getLoggedInUserId'],
             location_id: store.getters['location/selected'].id,
             in_store: store.getters['getInStore'] ? 1 : 0,
           },
         },
         function(status, response) {
           //console.log('user activity response')
           //console.log(status);
           // console.log(response);
         }
         )
       }
    },
    
    /**
     * Get location contact value
     */
    getContactValue(arr, type, field) {
      let obj = _.find(arr, { 'type': type });
      if (obj != undefined) {
        return obj[field];
      }
      if(type == 'phone'){
        // to maintain space
        return '&nbsp; <br/>';
      }
      return '';
    },

    /**
     * Calculate reward points
     */
    getRewardPoints(rewards) {
      let totalPoints =  0;
      rewards.map(item => {
        if(item.reward_type == 'points'){
          totalPoints += item.reward_points;
        }
      });
      return totalPoints + (totalPoints > 1 ? ' Points' : ' Point');
    },

    /**
     * Generate random text
     */
    generateRandomText(length) {
      const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = ' ';
      const charactersLength = characters.length;
      for ( let i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return result;

    },
    

   
};
